import api from './client';

export type SavedMessage = {
  role: 'user' | 'assistant';
  content: string;
  has_screenshot?: boolean;
  timestamp: string | Date;
};

export type ChatSessionSummary = {
  _id: string;
  session_id: string;
  title: string;
  message_count: number;
  updatedAt: string;
  createdAt: string;
};

export type ChatSessionFull = ChatSessionSummary & {
  messages: SavedMessage[];
  user_email: string;
  user_name: string;
};

type ApiResponse<T> = { success: boolean; data: T; message: string };

export const createChatSession = (payload: {
  session_id: string;
  title?: string;
}) =>
  api.post<ApiResponse<{ session_id: string; _id: string }>>('/chat/sessions', payload);

export const saveChatSession = (
  session_id: string,
  payload: { messages: SavedMessage[]; title?: string },
) => api.put<ApiResponse<{ session_id: string; message_count: number }>>(`/chat/sessions/${session_id}`, payload);

export const getChatSessions = (params?: { page?: number; limit?: number }) =>
  api.get<ApiResponse<{ sessions: ChatSessionSummary[]; total: number }>>('/chat/sessions', { params });

export const getChatSession = (session_id: string) =>
  api.get<ApiResponse<ChatSessionFull>>(`/chat/sessions/${session_id}`);

export const deleteChatSession = (session_id: string) =>
  api.delete<ApiResponse<null>>(`/chat/sessions/${session_id}`);

// ── AI message via backend (MCP + OpenAI) ──────────────────────────────────
export type BackendMessage = {
  role: 'user' | 'assistant';
  content: string;
  screenshotUrl?: string;
};

export type AiMessageResponse = ApiResponse<{
  content: string;
  exportData: Record<string, unknown>[] | null;
  usage: { prompt_tokens: number; completion_tokens: number; total_tokens: number };
}>;

export const sendAiMessage = (messages: BackendMessage[]) =>
  api.post<AiMessageResponse>('/chat-ai/message', { messages });
